export default __webpack_public_path__ + "static/vignette_newsletter_3-03e1d36c00113d8dfc469c7b5b340b0b.jpg";